async function carregaProdutos() {
  let retorna = []
  const dadosPedido = await JSON.parse(localStorage.getItem('itensPedido'))
  if (dadosPedido) retorna = dadosPedido.produtos
  return retorna
}
export default carregaProdutos
